import _export from '../internals/export.js';
import descriptors from '../internals/descriptors.js';
import anObject$1 from '../internals/an-object.js';
import toPropertyKey$1 from '../internals/to-property-key.js';
import '../internals/object-define-property.js';
import fails$1 from '../internals/fails.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';

var $ = _export;
var DESCRIPTORS = descriptors;
var anObject = anObject$1;
var toPropertyKey = toPropertyKey$1;
var definePropertyModule = objectDefineProperty;
var fails = fails$1; // MS Edge has broken Reflect.defineProperty - throwing instead of returning false

var ERROR_INSTEAD_OF_FALSE = fails(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.defineProperty(definePropertyModule.f({}, 1, {
    value: 1
  }), 1, {
    value: 2
  });
}); // `Reflect.defineProperty` method
// https://tc39.es/ecma262/#sec-reflect.defineproperty

$({
  target: 'Reflect',
  stat: true,
  forced: ERROR_INSTEAD_OF_FALSE,
  sham: !DESCRIPTORS
}, {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    var key = toPropertyKey(propertyKey);
    anObject(attributes);

    try {
      definePropertyModule.f(target, key, attributes);
      return true;
    } catch (error) {
      return false;
    }
  }
});
